module.exports = __webpack_public_path__ + "static/media/vegitables_21.5214e2c2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_21.csv
// module id = 604
// module chunks = 0